import Backbone from '@polleverywhere/backbone'

export function joinInstructionsSettingsFromApi (activitySharedKeys = []) {
  return Backbone.ajax({
    url: '/api/activities/join_instructions',
    dataType: 'json',
    data: {
      poll_shared_keys: activitySharedKeys
    }
  })
}
